import React from 'react';

import Input from '../../Input/components/Input';
import styles from './SearchBar.module.scss';

const SearchBar = React.forwardRef((props, ref) => {
  const prohibitedProps = [
    'class',
    'className',
    'type',
  ];

  prohibitedProps.forEach((key) => {
    if (key in props) {
      throw new Error(`Prop "${key}" is prohibited in SearchBar`);
    }
  });

  return (
    <Input
      ref={ref}
      className={styles.searchBar}
      type="text"
      {...props}
    />
  );
});

SearchBar.displayName = 'SearchBar';

export default SearchBar;
